import React from 'react';
import { Radio } from 'antd';

import './RadioButtonRow.scss';

function getDisplayName(value, mappings) {
  return mappings && mappings[value] ? mappings[value] : value;
}

function RadioButtonRow({
  datatestid,
  list,
  listKey = null,
  listValue = null,
  onChange,
  defaultValue,
  value,
  displayNameMappings,
  customButtonClassname,
}) {
  const buildRadioProps = (listObject, index) => {
    const radioProps = {
      className: customButtonClassname,
    };
    let text = getDisplayName(listObject, displayNameMappings);

    if (listKey && listValue) {
      radioProps.key = listObject[listKey];
      radioProps.value = listObject[listKey];
      radioProps['data-testid'] = datatestid ? `${datatestid}-${index}` : null;
      text = listObject[listValue];
    } else {
      radioProps.key = listObject;
      radioProps.value = listObject;
      radioProps['data-testid'] = datatestid
        ? `${datatestid}-${listObject}`
        : null;
    }

    const handleEnterKeyPress = event => {
      if (event.key === 'Enter' || event.keyCode === 13) {
        onChange(radioProps.value);
      }
    };

    return (
      <Radio.Button {...radioProps} tabIndex={-1}>
        <span tabIndex={0} onKeyDown={handleEnterKeyPress} role="button">
          {text}
        </span>
      </Radio.Button>
    );
  };

  return (
    <div
      className="radioButtonRow horizontalScrollBar"
      data-testid={datatestid}
    >
      <Radio.Group
        data-testid={datatestid ? `${datatestid}-radio-group` : null}
        defaultValue={defaultValue}
        value={value}
        buttonStyle="outline"
        onChange={e => onChange(e.target.value)}
      >
        {list && list.length && list.map((v, i) => buildRadioProps(v, i))}
      </Radio.Group>
    </div>
  );
}
export default RadioButtonRow;
